(function () {
  'use strict';

  var bookingKey = '_Santa booking ID';
  var componentKey = '_Santa component';
  var bypassCheckout = false;

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function property(item, key) {
    return item && item.properties ? item.properties[key] : null;
  }

  function rules() {
    return window.FASantaRules;
  }

  function hasSantaLine(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      return Boolean(property(item, bookingKey) || property(item, componentKey));
    }));
  }

  function isSantaBasket(form) {
    if (document.body.classList.contains('has-santa-booking')) return true;
    if (!form) return false;
    return form.dataset.santaOrphanComponents === 'true' ||
      Boolean(form.querySelector && form.querySelector('[data-santa-booking-group]'));
  }

  // After a booking is removed the page reloads with #cart; move focus back to the basket.
  function restoreFocusAfterRemoval() {
    if (!window.location || window.location.hash !== '#cart') return;
    var target = document.querySelector('#main-content .js-ajax-cart-content .js-cart-form:not(.hide) .ajax-cart__cart-items') ||
      document.querySelector('#main-content .js-ajax-cart-content .js-cart-empty:not(.hide)') ||
      document.querySelector('#main-content');
    if (!target) return;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus();
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  // Give the first rendered orphan notice a status role; later Ajax refreshes stay silent.
  var orphanNoticeAnnounced = false;
  function markOrphanNotice() {
    var notice = document.querySelector('.js-ajax-cart-content [data-santa-orphan-notice]:not([role])');
    if (!notice || orphanNoticeAnnounced) return;
    notice.setAttribute('role', 'status');
    orphanNoticeAnnounced = true;
  }

  function setSantaState(cart) {
    document.body.classList.toggle('has-santa-booking', hasSantaLine(cart));
  }

  // Called by cart.js updateView after every basket render.
  function refreshState(cart) {
    setSantaState(cart);
    markOrphanNotice();
    restoreFocusAfterRemoval();
  }

  function fetchCart() {
    return fetch(routesRoot() + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('The basket could not be checked.');
      return response.json();
    });
  }

  function fetchCheckoutCart() {
    var idle = window.WAU && WAU.ThemeCart ? WAU.ThemeCart.whenIdle() : Promise.resolve();
    return idle.then(function () {
      return fetch(routesRoot() + 'cart?section_id=cart-validation', {
        cache: 'no-store', headers: { 'Accept': 'text/html' }
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('The basket could not be checked. Please try again.');
      return response.text();
    }).then(function (html) {
      var documentResult = new DOMParser().parseFromString(html, 'text/html');
      var element = documentResult.querySelector('[data-cart-validation]');
      if (!element) throw new Error('The basket could not be checked. Please refresh the page and try again.');
      var result = JSON.parse(element.textContent);
      if (result.valid !== true) throw new Error(result.message || 'The booking is no longer available.');
      if (!result.cart || !Array.isArray(result.cart.items)) throw new Error('The basket could not be checked.');
      return result.cart;
    });
  }

  function postUpdate(updates) {
    return fetch(routesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok) throw new Error(cart.description || 'The booking could not be removed.');
        return cart;
      });
    });
  }

  function findCartError(form) {
    return (form && form.querySelector('[data-santa-cart-error]')) ||
      document.querySelector('[data-santa-cart-error]');
  }

  function clearCartError(form) {
    var error = findCartError(form);
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function prefersReducedMotion() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Show the element first, then fill it, so the alert role announces the new text.
  function showCartError(form, message) {
    var error = findCartError(form);
    if (!error) {
      window.alert(message);
      return;
    }
    error.hidden = false;
    error.textContent = message;
    if (!error.getAttribute('tabindex')) error.setAttribute('tabindex', '-1');
    error.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
    error.focus({ preventScroll: true });
  }

  function setBusy(control, busy) {
    if (!control || typeof control.setAttribute !== 'function') return;
    if (busy) {
      control.setAttribute('aria-busy', 'true');
      if ('disabled' in control) control.disabled = true;
    } else {
      control.removeAttribute('aria-busy');
      if ('disabled' in control) control.disabled = false;
    }
  }

  function checkGroups(cart) {
    var result = rules().validateCart(cart);
    if (!result.valid) return result;
    for (var i = 0; i < result.bookingIds.length; i += 1) {
      var group = rules().validateGroup(cart.items, result.bookingIds[i]);
      if (!group.valid) return group;
    }
    return { valid: true };
  }

  var checkPending = false;

  function validateThenContinue(form, continueCheckout, control) {
    if (!isSantaBasket(form)) {
      continueCheckout();
      return;
    }
    if (checkPending) return;
    clearCartError(form);
    if (!rules()) {
      showCartError(form, 'The basket could not be checked. Please refresh the page and try again.');
      return;
    }
    if (form && form.dataset.santaOrphanComponents === 'true') {
      showCartError(form, rules().ORPHAN_MESSAGE);
      return;
    }
    checkPending = true;
    setBusy(control, true);
    fetchCheckoutCart()
      .then(function (cart) {
        setSantaState(cart);
        var result = checkGroups(cart);
        checkPending = false;
        setBusy(control, false);
        if (!result.valid) {
          showCartError(form, result.message);
          return;
        }
        continueCheckout();
      })
      .catch(function (error) {
        checkPending = false;
        setBusy(control, false);
        showCartError(form, error.message || 'The basket could not be checked. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-santa-remove-booking]');
    if (removeButton) {
      event.preventDefault();
      var group = removeButton.closest('[data-santa-booking-group]');
      var status = group ? group.querySelector('[data-santa-remove-status]') : null;
      removeButton.disabled = true;
      if (status) status.textContent = 'Removing the complete booking…';
      var idle = window.WAU && window.WAU.ThemeCart && window.WAU.ThemeCart.whenIdle
        ? window.WAU.ThemeCart.whenIdle()
        : Promise.resolve();
      idle
        .then(fetchCart)
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (item) {
            if (property(item, bookingKey) === removeButton.dataset.santaRemoveBooking) {
              updates[item.key] = 0;
            }
          });
          if (!Object.keys(updates).length) throw new Error('This booking is no longer in the basket.');
          return postUpdate(updates);
        })
        .then(function (cart) {
          setSantaState(cart);
          if (window.location.hash !== '#cart') window.location.hash = 'cart';
          window.location.reload();
        })
        .catch(function (error) {
          removeButton.disabled = false;
          if (status) status.textContent = error.message || 'The booking could not be removed. Please try again.';
        });
      return;
    }

    var checkoutLink = event.target.closest('a[href*="/checkout"]');
    var checkoutForm = checkoutLink ? checkoutLink.closest('form') : null;
    if (checkoutLink && !bypassCheckout && isSantaBasket(checkoutForm)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      validateThenContinue(checkoutForm, function () {
        bypassCheckout = true;
        window.location.assign(checkoutLink.href);
      }, checkoutLink);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (bypassCheckout) return;
    // Older Safari has no event.submitter; fall back to the focused checkout button.
    var submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.name !== 'checkout') return;
    var form = event.target;
    if (!isSantaBasket(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    validateThenContinue(form, function () {
      bypassCheckout = true;
      try {
        if (typeof form.requestSubmit === 'function' && submitter.form === form) {
          form.requestSubmit(submitter);
        } else {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'checkout';
          input.value = 'Checkout';
          form.appendChild(input);
          form.submit();
        }
      } finally {
        bypassCheckout = false;
      }
    }, submitter);
  }, true);

  // A checkout page restored from the back-forward cache must be checked again.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) bypassCheckout = false;
  });

  window.FASantaCart = { refreshState: refreshState };

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(setSantaState).catch(function () {});
  });
})();
